package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
data class Permission

(

    @JsName("role")        var role        : String,
    @JsName("scope")       var scope       : String,
    @JsName("write")       var write       : Boolean = false,

)

{

    fun id() = "P${hashCode().toLong()+Int.MAX_VALUE}"

    fun duplicate() = Permission(role = role, scope = scope, write = write)

}

val LIFECYCLE_SCOPE            = "pincer.lifecycle"
val NAME_SCOPE                 = "pincer.name"
val DESCRIPTION_SCOPE          = "pincer.description"
val CHATS_SCOPE                = "pincer.chats"
val CANDIDATES_SCOPE           = "pincer.candidates"
val SELECTED_SCOPE             = "pincer.selected"
val QUESTIONS_SCOPE            = "pincer.questions"
val PARTICIPANTS_SCOPE         = "pincer.participants"
val PARTICIPANTS_RULES_SCOPE   = "pincer.participants.rules"
val PARTICIPANTS_ROLES_SCOPE   = "pincer.participants.roles"
val PARTICIPANTS_ANSWERS_SCOPE = "pincer.participants.answers"
val PERMISSIONS_SCOPE          = "pincer.permissions"
val PARTICIPATIONS_SCOPE       = "pincer.participations"
val RULES_SCOPE                = "pincer.rules"
val FORK_SCOPE                 = "pincer.fork"
